import {RefObject, useEffect, useState} from 'react'
import {
  ActionButton,
  Button,
  ChipStatus,
  Dialog,
  DialogAction,
  DialogContent,
  DialogRef,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'src/app/components'

export type BankRewardCodesDialogProps = {
  dialogRef?: RefObject<DialogRef>;
  bank_reward_codes?: string[];
  onDelete: (index: number) => void;
};

const BankRewardCodesDialog = (props: BankRewardCodesDialogProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [filteredCodes, setFilteredCodes] = useState<string[]>([])

  useEffect(() => {
    const filtered = props.bank_reward_codes?.filter((item: any) =>
      item.code.toLowerCase().includes(searchTerm.toLowerCase()),
    )
    setFilteredCodes(filtered!)
  }, [searchTerm, props.bank_reward_codes])

  return (
    <Dialog
      closeOnBackdropClicked={true}
      title={'List Voucher from Tenant'}
      ref={props.dialogRef}
      size="md"
      onHide={()=>{setSearchTerm('')}}
    >
      <DialogContent>
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by voucher code"
            className="w-1/3 px-4 py-2 border border-gray-300 text-black rounded-md"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No. </TableCell>
              <TableCell>Voucher Code</TableCell>
              <TableCell>Status</TableCell>
              <TableCell action />
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCodes?.map((item: any, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.code}</TableCell>
                <TableCell>
                  <ChipStatus state={item.status} />
                </TableCell>
                <TableCell action>
                  {item.status.toLowerCase() === 'available' && (
                    <ActionButton
                      size="md"
                      variant="delete"
                      onClick={() => props.onDelete(index)}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogAction>
        <Button
          onClick={() => {
            props.dialogRef?.current?.hide()
          }}
          variant="outlined"
        >
          Close
        </Button>
      </DialogAction>
    </Dialog>
  )
}

export default BankRewardCodesDialog